import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useAuth, useRestaurant } from '../../hooks';
import { restaurantService } from '../../services';
import { useAPI } from '../../hooks/useAPI';
import { addRestaurant, setRestaurantsLoaded } from '../../store/slices/restaurantSlice';

export function RestaurantInitializer({ children }) {
    const { user, isOwner, getAssociatedRestaurant, isInitialized } = useAuth();
    const { restaurants, selectedRestaurantId, setRestaurants, setSelectedRestaurantId } = useRestaurant();
    const { execute } = useAPI();
    const dispatch = useDispatch();

    useEffect(() => {
        if (!isInitialized) {
            return;
        }

        if (!user) {
            setRestaurants([]);
            setSelectedRestaurantId(null);
            dispatch(setRestaurantsLoaded(false));
            return;
        }

        if (isOwner()) {
            const loadOwnerRestaurants = async () => {
                try {
                    const response = await execute(() => restaurantService.getRestaurants());
                    setRestaurants(response.data);
                } catch (error) {
                    console.error('Error fetching restaurants:', error);
                    setRestaurants([]);
                } finally {
                    dispatch(setRestaurantsLoaded(true));
                }
            };

            loadOwnerRestaurants();
        } else {
            dispatch(setRestaurantsLoaded(true));

            const associatedRestaurantId = getAssociatedRestaurant();
            if (associatedRestaurantId) {
                setSelectedRestaurantId(associatedRestaurantId);

                const fetchAssociatedRestaurant = async () => {
                    try {
                        const response = await execute(() => restaurantService.getRestaurant(associatedRestaurantId));
                        if (response.data) {
                            dispatch(addRestaurant(response.data));
                        }
                    } catch (error) {
                        console.error('Error fetching associated restaurant:', error);
                    }
                };

                fetchAssociatedRestaurant();
            }
        }
    }, [user, isInitialized, execute, dispatch, isOwner, getAssociatedRestaurant, setRestaurants, setSelectedRestaurantId]);

    useEffect(() => {
        if (isOwner() && restaurants.length > 0 && selectedRestaurantId === null) {
            setSelectedRestaurantId(restaurants[0]._id);
        }
    }, [restaurants, selectedRestaurantId, isOwner, setSelectedRestaurantId]);

    return children;
}
